import { render, staticRenderFns } from "./noLine.vue?vue&type=template&id=80c3b8ae&scoped=true"
import script from "./noLine.vue?vue&type=script&lang=js"
export * from "./noLine.vue?vue&type=script&lang=js"
import style0 from "./noLine.vue?vue&type=style&index=0&id=80c3b8ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c3b8ae",
  null
  
)

export default component.exports